import { render } from "./EditServiceDialog.vue?vue&type=template&id=303d4b9e&scoped=true&ts=true"
import script from "./EditServiceDialog.vue?vue&type=script&lang=ts"
export * from "./EditServiceDialog.vue?vue&type=script&lang=ts"

import "./EditServiceDialog.vue?vue&type=style&index=0&id=303d4b9e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303d4b9e"]])

export default __exports__